<div class="heading heading_standard heading_centered">Forgot password?</div>
<div class="form__desc">
  I rememeber login details.
  <a routerLink="/auth/sign-in"><strong>Login</strong></a>
</div>

<form
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  [appScrollToInvalidFieldOnFormSubmit]
  [scrollElement]="ScrollElements.WINDOW"
>
  <div class="fields">
    <div
      class="fields__item fields__item_full"
      [appIfInvalid]="emailFC"
      [validationErrors]="{
        required: 'Please, enter e-mail address',
      }"
    >
      <input
        [formControl]="emailFC"
        type="text"
        placeholder=""
        autocomplete="E-mail address"
        id="email"
      />
      <label for="email">E-mail address</label>
      <ng-template [appErrorsHost] />
    </div>

    <button
      type="submit"
      class="button button_dark button_standard button_centered"
    >
      Reset password
    </button>

    <p>
      Please enter the email address you used to register on our website, so we
      can send you a link to reset your password.
    </p>
  </div>
</form>
